/**
 * The ads' demo sites, shown live on the first screen of an ad visit (2026-10-04,
 * landing_pages/docs/preview-first-journey-handoff.md v2, step 1). From
 * landing_pages/saddle-ads/launch/2026-10/ads.csv: each ad links here with its demo's sentence as
 * `?idea=` and its name as `utm_content` (`Golf-W1-A`).
 *
 * These are PROTECTED slugs: shown, never modified, unlisted or republished (docs/PROTECTED-SLUGS.md).
 * Only these five may be framed by the builder (site.ts PREVIEW_DEMO_SLUGS keeps the same list).
 */
export interface AdDemo {
  /** The ad family, as utm_content starts: `Golf` in `Golf-W1-A`. */
  ad: string;
  slug: string;
  /** The sentence the demo was built from, which the ad links with. */
  sentence: string;
}

export const AD_DEMOS: AdDemo[] = [
  {
    ad: 'Wedding',
    slug: 'mia-theo-sonoma-2027-2',
    sentence: "A wedding website for Mia and Theo's weekend in Sonoma, June 11-13, 2027: the schedule for each day, where to stay, and an RSVP where each guest says if they're coming, picks their meal and can add a plus-one.",
  },
  {
    ad: 'Trip',
    slug: 'lisbon-2027-the-plan',
    sentence: "A shared itinerary for our group trip to Lisbon, May 14-19, 2027: each day planned with times and places, where we are staying, everyone's flights, and a packing list, so the whole group can see the plan on their phones.",
  },
  {
    ad: 'Potluck',
    slug: 'block-party-potluck-2',
    sentence: "A potluck sign-up for our street's summer block party on Saturday, July 17, 2027: people say what dish they are bringing (main, side, dessert or drinks) so we do not end up with ten salads, and everyone can see what is already covered.",
  },
  {
    ad: 'Volunteer',
    slug: 'food-bank-shifts-3',
    sentence: "A volunteer sign-up for our food bank: a calendar of the next four weeks of shifts, each with a time and how many volunteers it needs; volunteers pick a shift and sign up, and a shift closes when it's full.",
  },
  {
    ad: 'Golf',
    slug: 'fairway-ledger',
    sentence: 'A golf tracker where I log each round with my score on every hole and the club I used for each stroke, and see over time how far and how well I hit each club, with charts.',
  },
];

export const SITE_ORIGIN = 'https://app.saddle-sites.com';

/** The demo an ad visit came for: by the ad's name first, then by the exact sentence it linked. */
export function demoForVisit(utmContent: string | undefined, idea: string | undefined): AdDemo | null {
  const family = (utmContent ?? '').split('-')[0]?.toLowerCase();
  const byAd = family ? AD_DEMOS.find((d) => d.ad.toLowerCase() === family) : undefined;
  if (byAd) return byAd;
  const said = (idea ?? '').trim();
  return said ? AD_DEMOS.find((d) => d.sentence === said) ?? null : null;
}
